<div class="grafico-eventos" [class.con-card]="card()">
  <!-- Toolbar: alternar abiertos / histórico (siempre visible) -->
  <div class="ge-toolbar">
    <button
      irxBoton="secundario"
      tamano="compacto"
      type="button"
      (click)="toggleHistorico()"
      [tooltip]="
        mostrarHistorico()
          ? 'Mostrando todos los eventos (incluye finalizados)'
          : 'Mostrando solo eventos abiertos'
      "
    >
      <mat-icon>
        {{ mostrarHistorico() ? 'history' : 'pending_actions' }}
      </mat-icon>
      {{ mostrarHistorico() ? 'Históricos' : 'Abiertos' }}
    </button>

    <!-- Acciones extra opcionales (ej. botón de ayuda del contenedor), alineadas
         a la derecha en la misma fila que el toggle. -->
    <ng-content select="[toolbar-actions]"></ng-content>
  </div>

  @if (cargando()) {
    <div class="ge-estado">
      <mat-spinner diameter="36"></mat-spinner>
      <p>Cargando eventos…</p>
    </div>
  } @else if (!hayDatos()) {
    <div class="ge-estado ge-vacio">
      <mat-icon>check_circle</mat-icon>
      @if (mostrarTitulo()) {
        <p>{{ titulo() }}</p>
      }
      <span>
        {{
          mostrarHistorico()
            ? 'No hay eventos en el histórico.'
            : 'No hay eventos abiertos.'
        }}
      </span>
    </div>
  } @else {
    <app-graficos
      tipo="bar"
      [series]="series()"
      [categorias]="categorias()"
      [titulo]="mostrarTitulo() ? titulo() : ''"
      [subtitulo]="mostrarHistorico() ? 'Histórico (todos)' : 'Abiertos'"
      tituloEjeX="Tipo de alarma"
      tituloEjeY="Cantidad de eventos"
      [altura]="altura()"
      [mostrarLeyenda]="false"
      [mostrarEtiquetas]="true"
      [permitirDecimales]="false"
      [ocultarLabelsEjes]="false"
    ></app-graficos>
  }
</div>
